import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Stack, Card, CardContent, Typography } from 'components/base';
import { PersonAddAlt1OutlinedIcon } from 'assets/icons';
import { Button } from 'components/atoms';
import { ErrorBoundary } from 'components/molecules';
import { iconDiv } from '../../styles';
import { FirstName, LastName, Email, Company } from './FormFields';
import { INFO_COLLECTION_DEFAULT_VALUES } from '../../constants';
import { infoCollectionSchema } from './Validatiion';
import { InfoCollectionFormType } from '../../types';
import { useInfoCollection } from '../../hooks/useInfoCollection';

export const InfoCollection: React.FC = () => {
  const methods = useForm<InfoCollectionFormType>({
    defaultValues: INFO_COLLECTION_DEFAULT_VALUES,
    resolver: zodResolver(infoCollectionSchema),
    mode: 'onChange',
  });
  const { handleSaveInfo, isSaveInfoLoading } = useInfoCollection(methods);

  return (
    <Card raised sx={{ maxWidth: '80%' }}>
      <CardContent>
        <Stack p={2} spacing={2}>
          <Stack sx={iconDiv} bgcolor="primary.background">
            <PersonAddAlt1OutlinedIcon fontSize="large" color="primary" />
          </Stack>
          <Typography variant="h5" color="text.primary" alignSelf="center">
            Welcome to Varicon!
          </Typography>
          <Typography variant="body2" color="text.secondary" alignSelf="center">
            It looks like you&apos;re new here. Please provide a few details to
            create your <strong>Varicon ID</strong> for future submissions.
          </Typography>
          <FormProvider {...methods}>
            <ErrorBoundary>
              <FirstName />
              <LastName />
              <Email />
              <Company />
            </ErrorBoundary>
          </FormProvider>
          <Button onClick={handleSaveInfo} isLoading={isSaveInfoLoading}>
            Save Info
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
};
